export let dispatchFunction = identity => identity;

export function dispatch(...args) {
  return dispatchFunction(args[0]);
}

export function setDispatch(func) {
  dispatchFunction = func;
}

export function bindToDispatch(func) {
  return (...args) => dispatch(func(...args));
}

export function bindActionMapToDispatch<ACS>(actionCreators: ACS): ACS {
  return Object.keys(actionCreators).reduce(
    (result, key) => {
      return Object.assign(result, { [key]: (...args: any) => dispatch(actionCreators[key](...args)) });
    },
    {} as ACS
  );
}
